import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core'
import { MediaObserver, MediaChange } from '@angular/flex-layout'
import { ChartInfo } from 'src/app/models/chart.model'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-chart-items',
  template: `
  <mat-card class="chart-container">
    <mat-card-content class="chart-content">

      <div
        fxLayout="row wrap"
        fxLayoutGap="8px"
        fxLayoutAlign="start center"
      >
        <h3>
          {{ chartName }}
        </h3>

        <div fxFlex="1 1 auto"></div>

        @if (help) {
          <mat-icon class="help" [matTooltip]="help">
            help_outline
          </mat-icon>
        }

        @if (!dataCollections) {
        } @else {
          <img
            class="datafix_icon"
            matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
            src="./assets/data_collections.png"
          />
        }
      </div>

      <div class="chart-card">
        @for (info of infos; track info) {

          <mat-list>

            <div mat-subheader>
              {{ info.subName }}
            </div>

            @for (rankingItem of info.chart; track rankingItem) {
              <div class="ranking-row">

                <mat-icon class="chart-icon">
                  {{ info.icon }}
                </mat-icon>

                <div class="ranking">
                  <span class="rank-number">
                    {{ rankingItem.currentRank }}
                  </span>
                  位
                </div>

                <div class="ranking-detail">

                  <div class="title">
                    {{ rankingItem.title }}
                  </div>

                  <div class="rank">
                    （ 前週
                    {{ rankingItem.previousRank === null ? '-' : rankingItem.previousRank }}
                    位、最高
                    {{ rankingItem.rankTop }}
                    位 ）
                  </div>

                </div>

              </div>
            }

          </mat-list>
        }
      </div>

    </mat-card-content>
  </mat-card>
`,
    styleUrls: ['./chart-items.component.scss'],
    standalone: false
})
export class ChartItemsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = []

  constructor(public media: MediaObserver) {
    this.subscriptions.push(media.asObservable().subscribe(() => {}))
  }

  @Input()
  infos: { chart: ChartInfo[]; subName: string; icon: string }[]

  @Input()
  chartName: string

  @Input()
  help: string

  @Input()
  dataCollections: boolean

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach(it => it.unsubscribe())
  }
}
